import * as types from '../../constants/user/postConstants';

export const postListRequest = ({
  page,
  pageLength,
  postType,
  attachedPer,
  attachedXper,
  isAttachedItem,
  attachedItem,
  sentAt,
  expireAt,
  searchString,
  itemName,
  postNo,
  accountNo,
  callback,
  error,
}) => ({
  type: types.POST_LIST_REQUEST,
  page,
  pageLength,
  postType,
  attachedPer,
  attachedXper,
  isAttachedItem,
  attachedItem,
  sentAt,
  expireAt,
  searchString,
  itemName,
  postNo,
  accountNo,
  callback,
  error,
});

export const postDetailsRequest = ({
  postNo,
  searchString,
  callback,
  error,
}) => ({
  type: types.POST_DETAILS_REQUEST,
  postNo,
  searchString,
  callback,
  error,
});

export const postExcelDownload = (postNo) => ({
  type: types.POST_EXCEL_DOWNLOAD,
  postNo
});

export const postItemSearchRequest = (searchString) => ({
  type: types.POST_ITEM_SEARCH_REQUEST,
  searchString,
});

export const setPostItemList = (list) => ({
  type: types.SET_POST_ITEM_LIST,
  list,
});

export const postUserSearchRequest = (searchString) => ({
  type: types.POST_USER_SEARCH_REQUEST,
  searchString
});

export const setPostUserList = (list) => ({
  type: types.SET_POST_USER_LIST,
  list
});

export const postCreateRequest = (
  sentAt, expireAt, title, content, per, xper, items, userDataType, users, excelFile
) => ({
  type: types.POST_CREATE_REQUEST,
  sentAt,
  expireAt,
  title,
  content,
  per,
  xper,
  items,
  userDataType,
  users,
  excelFile
});

/**
 * The postDepositRequest function is a Redux action creator that returns an object with the type property set to POST_DEPOSIT_REQUEST.
 *
 * @param {number} postNo Identify the post that is being deposited to
 * @param {number} tokenType Determine which token to deposit
 * @param {string} transactionHash Store the transaction hash of the deposit
 * @param callback
 * @param error
 */
export const postDepositRequest = ({
  postNo,
  tokenType,
  transactionHash,
  callback,
  error,
}) => ({
  type: types.POST_DEPOSIT_REQUEST,
  postNo,
  tokenType,
  transactionHash,
  callback,
  error,
});

/**
 * @param {number} resultCode 서버로부터 받은 결과 코드
 * @param {string} message 결과에 따른 메시지
 * */
export const postResponse = (resultCode, message) => ({
  type: types.POST_RESPONSE_MESSAGE,
  resultCode,
  message,
});

export const postRemoveRequest = ({
  postNo,
  callback,
  error,
}) => ({
  type: types.POST_REMOVE_REQUEST,
  postNo,
  callback,
  error,
});
